<template>
    <div class="go-step-page">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "go-step-page",
        props: {
            title: {
                type: String,
                default: ""
            }
        },
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-step-page.vue